import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";


export const get_All_Count = createAsyncThunk(
    "community/get_All_Count",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.get("community/all-count");
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response ? error.response.data : error.message
        );
      }
    }
  );
  